'use strict';

angular.module('app.common')

  .directive('howToBuyButton', [ '$document', '$timeout', function($document, $timeout) {
    function link(scope, element, attrs) {
      scope.gaEventPagename = attrs.gaEventPagename + ' Page';
      $timeout(function() {
        angular.element($document).foundation('reveal');
      }, 0);
    }

    return {
      restrict: 'E',
      scope: true,
      templateUrl: 'app/common/directives/howtobuybutton/howToBuyButton.html',
      link: link
    }
  } ]);



// WEBPACK FOOTER //
// ./app/common/directives/howtobuybutton/howToBuyButton.js